<template>
  <div class="modal-card">
    <div class="row-width-actions-bar">
      <div class="columns is-gapless is-vcentered is-border-bottom">
        <div class="column is-padding-left">
          <div class="has-text-dark is-size-6 is-uppercase">
            <span class="has-text-weight-medium">{{ params.title || 'Documents' }}</span>
          </div>
        </div>
        <div class="column is-narrow is-border-left">
          <a
            class="page-header-btn is-small is-square"
            @click="close">
            <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
          </a>
        </div>
      </div>
    </div>
    <section class="modal-card-body is-paddingless is-clipped">
      <form class="columns is-multiline is-padding">
        <div class="column is-4">
          <r-label
            :label="'Nom de la société'"
            :red-check="true"
            :value="promoteur.company_name"></r-label>
          <v-input
            id="company_name"
            name="company_name"
            @input="val => promoteur.company_name = val"
            :model="promoteur.company_name"
            data-vv-as="Nom de la société"
            v-validate="'min:2'"
            :errors-bag="errors"
            data-vv-value-path="val">
          </v-input>
        </div>
        <div class="column is-4">
          <r-label
            :label="'Nom du représentant'"
            :value="promoteur.rep_last_name"
            :red-check="true"></r-label>
          <v-input
            id="last_name"
            name="last_name"
            @input="val => promoteur.rep_last_name = val"
            :model="promoteur.rep_last_name"
            data-vv-as="Nom"
            v-validate="'min:2'"
            :errors-bag="errors"
            data-vv-value-path="val">
          </v-input>
        </div>
        <div class="column is-4">
          <r-label
            :label="'Prénom du représentant'"
            :value="promoteur.rep_first_name"
            :red-check="true"></r-label>
          <v-input
            id="first_name"
            name="first_name"
            @input="val => promoteur.rep_first_name = val"
            :model="promoteur.rep_first_name"
            v-validate="'min:2'"
            :errors-bag="errors"
            data-vv-value-path="val"
            data-vv-as="Prénom">
          </v-input>
        </div>
        <div class="column is-6">
          <r-label
            :label="'Adresse mail'"
            :value="promoteur.rep_email"
            :red-check="true"></r-label>
          <div class="field has-addons">
            <div class="control">
              <a class="button is-static is-border is-square">
                <span class="icon"><i class="fas fa-paper-plane"></i></span>
              </a>
            </div>
            <div class="control is-expanded">
              <v-input
                id="email"
                name="email"
                @input="val => promoteur.rep_email = val"
                :model="promoteur.rep_email"
                class=""
                v-validate="'email'"
                :errors-bag="errors"
                data-vv-value-path="val"
                data-vv-as="Email">
              </v-input>
            </div>
          </div>
        </div>
        <div class="column is-6">
          <r-label
            :label="'Téléphone'"
            :value="promoteur.rep_phone"
            :red-check="true"
            :truncate="false">
            <span
              class="is-padding-left-xsmall"
              v-helper.right="'6BNfgrh0uP7V5UyMRsZvQp'">
              <i class="fal fa-info-circle"></i>
            </span>
          </r-label>
          <div class="field has-addons">
            <div class="control">
              <a class="button is-static is-border is-square">
                <span class="icon"><i class="fas fa-phone-office"></i></span>
              </a>
            </div>
            <div class="control is-expanded">
              <v-input
                id="promoteurPhone"
                name="promoteurPhone"
                @input="val => promoteur.rep_phone = val"
                :model="promoteur.rep_phone"
                v-validate="'required|min:10'"
                :errors-bag="errors"
                data-vv-value-path="val"
                :placeholder="'06xxxxxxxx / +336xxxxxxxx'"
                data-vv-as="Téléphone">
              </v-input>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <address-input
            :source="address"
            :red-check="true"
            :is-required="true"
            @update="updateAddress">
          </address-input>
        </div>
      </form>
    </section>
    <div class="formActionsSticky is-bottom">
      <div class=" columns is-gapless is-centered has-background-white is-padding-top-small is-padding-bottom-small">
        <div class="column is-4 is-3-widescreen is-margin-right-small">
          <a
            @click="close()"
            class="button is-light is-uppercase is-fullwidth">
            <span>Annuler</span>
          </a>
        </div>
        <div class="column is-4 is-3-widescreen is-margin-left-small">
          <button
            @click="submit"
            class="button is-success is-uppercase is-fullwidth has-text-white"
            type="submit">
            <span>Valider</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
  name: 'PromoteurEditModal',
  props: {
    active: {
      type: Boolean,
      required: true
    },
    source: {
      type: Object,
      required: true
    },
    params: {
      type: Object
    }
  },
  data () {
    return {
      open: {},
      promoteur: {},
      address: {}
    }
  },
  computed: {
    promoteurContact () {
      return this.source
    }
  },
  created () {
    this.promoteur = cloneDeep(this.promoteurContact)
    if (this.promoteur.rep_address) {
      this.address = Object.assign({}, this.promoteur.rep_address)
    }
  },
  methods: {
    updateAddress (address) {
      this.$set(this, 'address', address)
      this.promoteur.rep_address = this.address
    },
    close () {
      this.$emit('close')
    },
    submit () {
      if (this.promoteur.rep_address) {
        if (this.promoteur.rep_address.city === '' || this.promoteur.rep_address.line1 === '' || this.promoteur.rep_address.country === '' || this.promoteur.rep_address.zip_code === '') this.promoteur.rep_address = {}
      }
      if (this.promoteur.company_name === '') this.promoteur.company_name = null
      if (this.promoteur.rep_first_name === '') this.promoteur.rep_first_name = null
      if (this.promoteur.rep_last_name === '') this.promoteur.rep_last_name = null
      if (this.promoteur.rep_phone === '') this.promoteur.rep_phone = null
      if (this.promoteur.rep_email === '') this.promoteur.rep_email = null
      this.$emit('submit', this.promoteur)
    }
  }
}
</script>
